/*
 * Copyright (c) 2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Typography } from 'antd'
import classNames from 'classnames'

const { Title } = Typography

interface ErrorWrapperProps {
  className?: string
  image?: React.ReactNode
  title: React.ReactNode
  subtitle: React.ReactNode
  children?: React.ReactNode
}

export default function ErrorWrapper({ image, title, subtitle, className, children }: ErrorWrapperProps) {
  return (
    <div className={classNames('flex w-full h-full items-center justify-center', className)}>
      <div className="flex flex-col items-center gap-y-4">
        {typeof image === 'string' ? <img src={image} /> : image}
        <div className="flex flex-col items-center">
          <Title className="pb-1" level={3}>
            {title}
          </Title>
          <div className="text-center text-common-textDescription">{subtitle}</div>
        </div>
        {children}
      </div>
    </div>
  )
}
